import type { ActivationCensusStep } from '../hooks/useActivationCensusFlow/activationCensus';
import { TRANSLATIONS_PROSPECTS } from '../translations/prospects';

const BACKGROUND = TRANSLATIONS_PROSPECTS.profile.activationSetup.census.background;

type StatusTone = 'info' | 'success' | 'warning';

interface IStatusCopy {
  tone: StatusTone;
  title: string;
  body: string;
  cta: string;
}

const RUNNING_STATUS: IStatusCopy = {
  tone: 'info',
  title: BACKGROUND.runningTitle,
  body: BACKGROUND.runningBody,
  cta: BACKGROUND.runningCta
};

export const CENSUS_BACKGROUND_ISSUES_STATUS: IStatusCopy = {
  tone: 'warning',
  title: BACKGROUND.issuesTitle,
  body: BACKGROUND.issuesBody,
  cta: BACKGROUND.issuesCta
};

export const CENSUS_BACKGROUND_STATUS_BY_STEP: Partial<Record<ActivationCensusStep, IStatusCopy>> = {
  validating: RUNNING_STATUS,
  processing: RUNNING_STATUS,
  success: {
    tone: 'success',
    title: BACKGROUND.successTitle,
    body: BACKGROUND.successBody,
    cta: BACKGROUND.successCta
  },
  'price-mismatch': {
    tone: 'warning',
    title: BACKGROUND.priceTitle,
    body: BACKGROUND.priceBody,
    cta: BACKGROUND.priceCta
  }
};
